module.exports = __webpack_public_path__ + "static/media/cy.f8994ae1.svg";